/**
 * Checks that the value is equal to one of the given options.
 * @typeparam T The type of the value.
 * @param values The values that the validated value can be.
 */
export const validateOneOf = (values) => {
    if (values.length === 0)
        throw new Error('oneOf values cannot be an empty array.');
    return (value, logger, logLabel) => {
        const valid = values.includes(value);
        if (!valid)
            logger(`${logLabel} must be one of: ${values.map(v => `'${v}'`).join(', ')}.`);
        return valid;
    };
};
//# sourceMappingURL=one-of.js.map